import axios from "axios";
import { configUrl } from "config.js";


export const getCollegesByRank = async (predictorType, startRank, endRank, branch, category, city, typeValue, quotaValue) => {
    try {
        const response = await axios.post(`${configUrl.PredictorServer}/predictor/${predictorType}/rank-range`, {
            start_rank: startRank,
            end_rank: endRank,
            branches: branch ? branch : ["All"],
            category: category || "All",
            category_gender_filter: typeValue || "All",
            category_region_filter: quotaValue || "All",
            city: city ? city : ["All"],
        });

        return response?.data;
    } catch (error) {
        console.error("Error fetching colleges by rank:", error);
        throw error;
    }
};

export const getPharmaCollegesByRank = async (startRank, endRank, branch, category, city, typeValue, quotaValue) => {
    try {
        const response = await axios.post(`${configUrl.PredictorServer}/getPharmaCollegesByRankRange`, {
            start_rank: startRank,
            end_rank: endRank,
            branches: branch ? branch : ["All"],
            category: category || "All",
            category_gender_filter: typeValue || "All",
            category_region_filter: quotaValue || "All",
            city: city ? city : ["All"],
        });

        return response?.data;
    } catch (error) {
        console.error("Error fetching colleges by rank:", error);
        throw error;
    }
};

export const getCollegesByPercentile = async (predictorType, startPercentile, endPercentile, branch, category, city, typeValue, quotaValue) => {
    try {
        const response = await axios.post(`${configUrl.PredictorServer}/predictor/${predictorType}/percentile-range`, {
            start_percentile: startPercentile,
            end_percentile: endPercentile,
            branches: branch ? branch : ["All"],
            category: category || "All",
            category_gender_filter: typeValue || "All",
            category_region_filter: quotaValue || "All",
            city: city ? city : ["All"],
        });

        return response?.data;
    } catch (error) {
        console.error("Error fetching colleges by rank:", error);
        throw error;
    }
};

export const getPharmaCollegesByPercentile = async (startPercentile, endPercentile, branch, category, city, typeValue, quotaValue) => {
    try {
        const response = await axios.post(`${configUrl.PredictorServer}/getPharmaCollegesByPercentileRange`, {
            start_percentile: startPercentile,
            end_percentile: endPercentile,
            branches: branch ? branch : ["All"],
            category: category || "All",
            category_gender_filter: typeValue || "All",
            category_region_filter: quotaValue || "All",
            city: city ? city : ["All"],
        });

        return response?.data;
    } catch (error) {
        console.error("Error fetching colleges by rank:", error);
        throw error;
    }
};